// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ServiceabilityStatus from "./ServiceabilityStatus.bs.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var startDateTime = DeccoUtils$Catalyst.DateUtils.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_date_time"), null));
  if (startDateTime.TAG === /* Ok */0) {
    var endDateTime = Decco.optionFromJson(DeccoUtils$Catalyst.DateUtils.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_date_time"), null));
    if (endDateTime.TAG === /* Ok */0) {
      var status = ServiceabilityStatus.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
      if (status.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  startDateTime: startDateTime._0,
                  endDateTime: endDateTime._0,
                  status: status._0
                }
              };
      }
      var e = status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".status" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = endDateTime._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".end_date_time" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = startDateTime._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".start_date_time" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

export {
  t_decode ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
